(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const ATTR_INITIAL_POSITION = 'initial-image-position';

    customElements.define('product-gallery', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]'
        }

        subscriptions = {
            'variant:change': '_onVariantChange'
        }

        render() {
            this._initSwiper();
            this.subscribe('variant:change');
        }

        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, {
                autoHeight: true,
                pagination: {
                    el: this.$pagination,
                    type: 'bullets',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<button class="' + className + '" aria-label="Go to slide '+ (index + 1) +'"></button>';
                      }
                },
                on: {
                    afterInit: function (swiper) {
                      if(swiper?.slides?.length) {
                        swiper.slides.forEach(element => {
                            console.log(element,"show element")
                            if(!element.classList.contains('swiper-slide-active')) {
                                element.setAttribute('aria-hidden','true')
                            }
                        });
                      }
                    },
                    slideChange: function (swiper) {
                    setTimeout(()=>{
                        if(swiper?.slides?.length) {
                            swiper.slides.forEach(element => {
                                if(!element.classList.contains('swiper-slide-active')) {
                                    element.setAttribute('aria-hidden','true')
                                }
                                else {
                                    element.removeAttribute('aria-hidden')
                                }
                            });
                          }
                    },300)
                    },
                    
                  },
                breakpoints: {
                    992: {
                        // allowTouchMove: false 
                    }
                }
            });
            if (this.initialPosition) {
                this.swiper.slideTo(+this.initialPosition - 1)
            }
        }

        _onVariantChange({ variantImagePosition}) {
            if(variantImagePosition) {
                this.swiper.slideTo(variantImagePosition - 1);
            }
        }

        get slider() {
            return this.swiper;
        }

        get initialPosition() {
            return this.getAttribute(ATTR_INITIAL_POSITION)
        }
    })
})();